module.exports = __webpack_public_path__ + "img/p2-p1-molihua.b99ef66f.png";